
import apiRequest from "./apiRequest";

export const Mbp3RegisterApi = {

    fetchMbp3Register: (accountId, token) => {
    return apiRequest(`/api/register/mbp-3?accountId=${accountId}`, 'GET', token);
  },
  

  // Submit MGT-1 form data
  submitMbp3Form: (formData, accountId, token) => {
    return apiRequest(`/api/register/mbp-3?accountId=${accountId}`, 'POST', token, formData);
  },

   addNewInvestments: (id, payload, token) => {
      return apiRequest(
        `/api/register/mbp-3/add-new/investments/${id}`,
        "POST",
        token,
        payload          // ← body is forwarded as-is to apiRequest
      );
    },


};